import { PersonAuthorizations } from './person';

export const RegisterOfficeOperationsList = [PersonAuthorizations.HistoryCancelEmigration];
